import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { ConfigService, StorageService } from '@services';

import { UserSession } from '@models';

@Injectable({
    providedIn: 'root'
})

export class DashboardGuard implements CanActivate {

    constructor(
        private configService: ConfigService,
        private router: Router,
        private storageService: StorageService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const userSession = this.storageService.getFromStorage<UserSession>(this.configService.userSessionKey);
        if (userSession) {
            const expires = new Date(userSession.expires);
            if (expires > new Date()) {
                return true;
            }
            this.storageService.removeFromStorage(this.configService.userSessionKey);
        }
        this.router.navigate(['login']);
        return false;
    }

}
